export default __webpack_public_path__ + "static/media/misc-books5-480w.ca3e739b.png";